import React from 'react'
import FilterRowItem from './FilterRowItem'
import PropTypes from 'prop-types'
import className from 'classnames'
import './FilterLabelsRow.scss'

const FilterLabelsRow = (props) => {
  let filterLabels = []
  let rowItemKey = 0
  if (window.innerWidth > 1024) {
    delete props.filterOptions['sort']
  }
  for (let label in props.filterOptions) {
    const optionInfo = props.filterOptions[label]

    let filterRowItem = (
      <FilterRowItem
        key={rowItemKey}
        active={props.activeDropdown === (optionInfo.filterValue || label)}
        hasDropdown={optionInfo.hasDropdown}
        value={optionInfo.filterValue || label}
        onClickFilterDropdown={optionInfo.onClickFilterDropdown}
        displayedLabel={
          optionInfo.displayedLabel ? optionInfo.displayedLabel : label
        }
        optionInfo={optionInfo}
      />
    )
    filterLabels.push(filterRowItem)
    rowItemKey++
  }

  const filterLabelsRowClass = className('FilterLabelsRow', {
    'FilterLabelsRow--center': props.centerContent
  })

  return <div className={filterLabelsRowClass}>{filterLabels}</div>
}

FilterLabelsRow.propTypes = {
  activeDropdown: PropTypes.string,
  filterOptions: PropTypes.object,
  value: PropTypes.string,
  centerContent: PropTypes.bool
}

export default FilterLabelsRow
